export default class BuildingCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-building-card', BuildingCard);
